import React from 'react'
import { toast } from 'react-toastify'
import { Box, Grid, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import { useMutation } from '@tanstack/react-query'
import RewardsAPI from 'api/faber/RewardsAPI'
import { Form, Formik } from 'formik'
import OrbitSession from 'hooks/useCookies'
import * as Yup from 'yup'

import NormalText from '../../../../common/Typography/NormalText'

const formikInitialValues = {
  distributorName: ''
}

const NewDistributorSchema = Yup.object().shape({
  distributorName: Yup.string().required('Distributor name is required')
})

const StyledTextField = styled(TextField)({
  '& input': {
    padding: '6px'
  },
  width: '100%'
})

export const NewDistributorForm = ({
  handleClose
}: {
  handleClose: () => void
}) => {
  const faberToken = OrbitSession.get('faberToken')

  const { mutate: createDistributor } = useMutation(
    RewardsAPI.createDistributor,
    {
      onSuccess: () => {
        toast.success('Distributor created successfully')
        handleClose()
      },
      onError: () => {
        toast.error('Error creating distributor')
      }
    }
  )

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFormSubmit = (values: NewDistributorFormikProps) => {
    const allValues = {
      distributorName: values.distributorName,
      faberToken: faberToken
    }
    createDistributor(allValues)
  }

  /**
   * Event handlers
   */
  return (
    <Formik
      initialValues={formikInitialValues}
      onSubmit={handleFormSubmit}
      validationSchema={NewDistributorSchema}
    >
      {({ submitForm, handleChange, errors, touched, handleBlur }) => (
        <Form>
          <Grid container rowSpacing={2}>
            <Grid item xs={3}>
              <NormalText isBold>Name</NormalText>
            </Grid>
            <Grid item xs={9}>
              <Box sx={{ width: '80%' }}>
                <StyledTextField
                  inputProps={{
                    'data-testid': 'distributor-name'
                  }}
                  name='distributorName'
                  onChange={(e) => {
                    handleBlur(e)
                    handleChange(e)
                  }}
                  fullWidth
                  variant='outlined'
                  error={!!(errors.distributorName && touched.distributorName)}
                  helperText={
                    errors.distributorName && touched.distributorName
                      ? errors.distributorName
                      : null
                  }
                />
              </Box>
            </Grid>
          </Grid>
          <Grid>
            <Box mt={3}>
              {' '}
              {/* Adjust the number to increase or decrease the space */}
              <Button autoFocus onClick={submitForm}>
                Save changes
              </Button>
            </Box>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

interface NewDistributorFormikProps {
  distributorName: string
}
